import { __styles } from "@griffel/react";
export const useRootStyles = __styles({
  "root": {
    "ycbfsm": "fg4l7m0"
  }
}, {
  "t": ["@media (forced-colors: active){.fg4l7m0{forced-color-adjust:auto;}}"]
});